import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "shareMobileClose",
  "use": "shareMobileClose-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 36 36\" xmlns=\"http://www.w3.org/2000/svg\" id=\"shareMobileClose\"><path d=\"m18 36c9.9411 0 18-8.0589 18-18 0-9.94113-8.0589-18-18-18-9.94113 0-18 8.05887-18 18 0 9.9411 8.05887 18 18 18z\" fill=\"#595153\" /><g stroke=\"#c1b6b0\" stroke-miterlimit=\"10\" stroke-width=\"1.25\"><path d=\"m24 24-12-12\" /><path d=\"m12 24 12-12\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol